import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingDocument, setProgressingDocument } from 'components/dynamic/dynamic-page/dynamic-page-activity-document/DynamicPageActivityDocumentSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  progressing: false,
};

const myRequestApprovalDocumentRecordSlice = createSlice({
  name: 'myRequestApprovalDocumentRecord',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
    setUpdateLineRecord(state, action) {
      const { record, subRecord, keyTableLine, lineUnid } = action.payload;
      const resRecord = record;
      const fieldNames = Object.keys(resRecord);
      const tmpRecord = { ...state.record };

      fieldNames.forEach((fieldName) => {
        tmpRecord[fieldName] = resRecord[fieldName];
      });

      const index = tmpRecord[keyTableLine].findIndex((element) => element.id.toString() === lineUnid.toString());
      if (index !== -1) {
        tmpRecord[keyTableLine][index] = subRecord;
        state.record = tmpRecord;
      }
    },
  },
});

const { setPageInfo, setFormLoading, setProgressing, setUpdateLineRecord } = myRequestApprovalDocumentRecordSlice.actions;

export const { setRecord } = myRequestApprovalDocumentRecordSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: document.id,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            if (!document.status) {
              dispatch(setViewingDocument(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

// export const updateRecord =
//   ({ url, unid, fieldName, valueChanged, record }) =>
//   async (dispatch) => {
//     try {
//       dispatch(setProgressingDocument(true));
//       dispatch(setProgressing(true));

//       let urlRequest = `${url}/submit-update-status?`;
//       urlRequest += `auth_token=${Service.userToken}`;

//       const data = JSON.stringify({
//         field_name: fieldName,
//         value: valueChanged,
//         unid,
//       });

//       RequestApi(urlRequest, {
//         data,
//       })
//         .then((res) => {
//           if (res.data.status === 'success') {
//             const resRecord = res.data.record;
//             const fieldNames = Object.keys(resRecord);
//             const tmpRecord = { ...record };

//             fieldNames.forEach((objFieldName) => {
//               tmpRecord[objFieldName] = resRecord[objFieldName];
//             });

//             dispatch(setRecord(tmpRecord));
//           } else {
//             NotificationMessage({ message: res.data.msg, status: res.data.status });
//           }
//           dispatch(setProgressingDocument(false));
//           dispatch(setProgressing(false));
//         })
//         .catch((err) => {
//           dispatch(setProgressingDocument(false));
//           dispatch(setProgressing(false));
//           NotificationMessage({ message: err.toString(), status: 'error' });
//         });
//     } catch (ex) {
//       dispatch(setProgressingDocument(false));
//       dispatch(setProgressing(false));
//       NotificationMessage({ message: ex.toString(), status: 'error' });
//     }
//   };

const myRequestApprovalDocumentRecordReducer = myRequestApprovalDocumentRecordSlice.reducer;

export default myRequestApprovalDocumentRecordReducer;
